<button class="close" mat-button mat-dialog-close>
  <mat-icon class="close-icon" color="warn" style="font-size: 16px !important"
    >close</mat-icon
  >
</button>
<h1 mat-dialog-title class="m-0 font-weight-bold titulo-header font-size-14">
  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>&nbsp;&nbsp;{{
    data.title
  }}
</h1>
<hr class="mt-1" />
<mat-dialog-content class="mat-typography">
  <div class="row">
    <div
      class="col-12 text-justify font-menu-titulo"
      style="letter-spacing: inherit"
    >
      {{ data.text }}
    </div>
    <div class="container pt-3">
      <div class="row justify-content-center mb-2">
        <div class="col-2 text-center">
          <a href="https://www.google.com/intl/pt-BR/chrome/" target="_blank"
            ><img
              src="./assets/img/chrome.png"
              alt="Chrome"
              width="26px"
              height="26px"
          /></a>
        </div>
        <div class="col-2 text-center">
          <a
            href="https://support.apple.com/pt_BR/downloads/safari"
            target="_blank"
            ><img
              src="./assets/img/safari.png"
              alt="Safari"
              width="26px"
              height="26px"
          /></a>
        </div>
        <div class="col-2 text-center">
          <a href="https://www.microsoft.com/pt-br/edge" target="_blank"
            ><img
              src="./assets/img/edge.png"
              alt="Edge"
              width="26px"
              height="26px"
          /></a>
        </div>
        <div class="col-2 text-center">
          <a href="https://www.mozilla.org/pt-BR/firefox/new/" target="_blank"
            ><img
              src="./assets/img/firefox.png"
              alt="Firefox"
              width="26px"
              height="26px"
          /></a>
        </div>
        <div class="w-100"></div>
      </div>
      <div class="row align-items-center justify-content-center">
        <div class="col-2" style="padding-left: 4px">
          <span class="font-size-12">Chrome</span>
        </div>
        <div class="col-2 text-center" style="padding-left: 10px">
          <span class="font-size-12">Safari</span>
        </div>
        <div class="col-2 text-center">
          <span class="font-size-12">Edge</span>
        </div>
        <div class="col-2 text-center" style="padding-left: 10px">
          <span class="font-size-12">Firefox</span>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
